module.exports = __webpack_public_path__ + "img/bug.11a0b421.png";